import classNames from 'classnames';
import React from 'react';
import Slider from 'react-slick';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import { SectionPaddingSide, SectionPaddingVertical } from '../../../../components/global/Layout';
import { EXPERIMENT_PAGE_DESIGN_FLAGS } from '../../../../experiments/constants';
import { useExperimentVariantData } from '../../../../experiments/hooks';
import { getKidsCreatorData } from './data';

const styles = require('./KidsBecomeCreators.module.css');

const iconURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/accounts/joyfulandempowering`;
const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/flagship/kids-become-creators`;

const kidsCreatorsSettings = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '30px',
  initialSlide: 0,
  swipeToSlide: true,
  draggable: true,
  arrows: true,
  dots: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        centerPadding: '30px',
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 567,
      settings: {
        centerPadding: '5px',
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 360,
      settings: {
        centerMode: false,
        arrows: false,
        dots: true,
        variableWidth: false,
      },
    },
  ],
};

const SlideIconWithText = ({ className, textVariant, icon, text }) => {
  return (
    <div className={classNames(styles.iconWrapper, className)}>
      <div className={styles.icon}>
        <img src={icon} alt="" />
      </div>
      <CodeSparkThemedTypography variant={textVariant} className={styles.iconText} Element="span">
        {text}
      </CodeSparkThemedTypography>
    </div>
  );
};

const KidsBecomeCreatorsSlide = ({
  img,
  title,
  icon,
  poster,
  played,
  liked,
  remixed,
  borderColor,
}) => {
  return (
    <div style={{ borderColor }} className={styles.kidsCreatorsSlide}>
      <div className={styles.kidsCreatorsSlideImgWrapper}>
        <img src={`${imgURL}/${img}`} alt={title} />
      </div>

      <div className={styles.kidsCreatorsSlideContent}>
        <div className={styles.kidsCreatorsSlideInfo}>
          <CodeSparkThemedTypography variant="h4" className={styles.kidsCreatorsSlideTitle}>
            {title}
          </CodeSparkThemedTypography>

          <SlideIconWithText
            icon={`${iconURL}/${icon}`}
            textVariant="body2"
            text={poster}
            className={styles.kidsCreatorsSlideInfoPoster}
          />
        </div>

        <div className={styles.kidsCreatorsSlideStats}>
          <SlideIconWithText
            icon={`${iconURL}/Icon_AmountPlayed_navyblue@2x.svg`}
            textVariant="button3"
            text={`${played} played`}
          />
          <SlideIconWithText
            icon={`${iconURL}/Icon_AmountLiked_navyblue@2x.svg`}
            textVariant="button3"
            text={`${liked} liked`}
          />
          <SlideIconWithText
            icon={`${iconURL}/Icon_AmountRemixed_navyblue@2x.svg`}
            textVariant="button3"
            text={`${remixed} remixed`}
          />
        </div>
      </div>
    </div>
  );
};

const experimentVariants = [
  'kidsBecomeCreatorsVariant1',
  'kidsBecomeCreatorsVariant2',
  ...EXPERIMENT_PAGE_DESIGN_FLAGS,
];
function KidsBecomeCreators() {
  const { title, subtitle, carousel } = useExperimentVariantData(
    experimentVariants,
    getKidsCreatorData
  );

  return (
    <SectionPaddingVertical className={styles.kidsCreatorsSection}>
      <SectionPaddingSide>
        <CodeSparkThemedTypography variant="h2" className={styles.kidsCreatorsTitle}>
          {title}
        </CodeSparkThemedTypography>

        <CodeSparkThemedTypography variant="subtitle1" className={styles.kidsCreatorsSubtitle}>
          {subtitle}
        </CodeSparkThemedTypography>
      </SectionPaddingSide>

      <Slider {...kidsCreatorsSettings} className={styles.kidsCreatorsSlider}>
        {carousel.map((kidsCreator, i) => {
          return (
            <div key={`kids_creator_slide_${i}`}>
              <KidsBecomeCreatorsSlide {...kidsCreator} />
            </div>
          );
        })}
      </Slider>
    </SectionPaddingVertical>
  );
}

export default KidsBecomeCreators;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/KidsBecomeCreators/index.js